// The Settings scope page's pure rules (spec 2026-10-18-full-separation §7.2). The server
// owns every decision -- kind, editable, why, masking (app/routers/settings.py); this only
// decides what to draw and whether Save may send. settings-scope.jsx and settings.jsx
// import it through esbuild; node --test covers it.

export const INSTALLATION = 'installation';

// A secret's display, never its value. The server refuses this text written back
// (masked_echo), and looksMasked below is the same rule, so Save never sends it.
export const maskText = (v) => (v && v.set ? `••••${v.last4 || ''}` : '');

const MASKED = /^[*•…][*•…\s]*\S{0,4}$/u;

export function looksMasked(text) {
  const s = String(text ?? '').trim();
  if (!s || MASKED.test(s)) return true;
  if (s.startsWith('{')) {
    try {
      const doc = JSON.parse(s);
      const keys = doc && typeof doc === 'object' && !Array.isArray(doc) ? Object.keys(doc) : [];
      return keys.length > 0 && keys.every((k) => k === 'set' || k === 'last4');
    } catch {
      return false;
    }
  }
  return false;
}

// At a company scope: the company's own value, or inherited (from the installation or the
// code default). At the installation scope: set, or the code default.
export function badgeOf(row, scope) {
  if (scope === INSTALLATION) return row.source === 'default' ? 'default' : 'set';
  return row.source === 'own' ? 'own' : 'inherited';
}

export const canReset = (row, scope) => scope !== INSTALLATION && !!row.editable && row.source === 'own';

// A secret's input always starts empty: its display is a placeholder, never a value.
export const draftOf = (row) => (row.secret ? '' : (row.text ?? ''));

export function sendable(row, draft) {
  if (!row.editable) return false;
  if (row.secret) return !looksMasked(draft);
  return draft !== (row.text ?? '');
}

export function sections(rows) {
  const order = [];
  const by = new Map();
  for (const r of rows) {
    if (!by.has(r.section)) { by.set(r.section, []); order.push(r.section); }
    by.get(r.section).push(r);
  }
  return order.map((id) => [id, by.get(id)]);
}

// "Defaults for every company": the installation value of every tenant-kind key.
export const isDefault = (row, scope) =>
  scope === INSTALLATION && (row.kind === 'tenant_super' || row.kind === 'tenant_admin');

// An installation admin may pick any scope; a tenant admin -- its own named login, never an
// impersonation token -- only its own tenant (require_settings_admin is the rule).
export function scopesFor(role, me, tenants) {
  if (role === 'admin') return [INSTALLATION, ...(tenants || []).map((t) => String(t.id))];
  if (me && me.role === 'tenant' && me.user_id != null && me.tenant_admin && !me.via_admin
      && me.tenant_id != null) return [String(me.tenant_id)];
  return [];
}
